import { render, staticRenderFns } from "./WServerDataTable.vue?vue&type=template&id=27dab7cc&"
import script from "./WServerDataTable.vue?vue&type=script&lang=js&"
export * from "./WServerDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports